/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { List, ListItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import styles from "../../styles/footerStyle.js";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FONT_FAMILY } from "../../common/sharedFunctions.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  return (
    <footer className={footerClasses}>
      <div
        className={classes.container}
        style={{ 
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "20px" }}>
          <List className={classes.list} style={{ display: "flex", justifyContent: "center", margin: 0 }}>
            <ListItem className={classes.inlineBlock}>
              <a
                style={{ cursor: "pointer", fontFamily: FONT_FAMILY }}
                className={classes.block}
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/term-condition");
                }}
              >
                {t("term_condition")}
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                style={{ cursor: "pointer", fontFamily: FONT_FAMILY }}
                className={classes.block}
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/privacy-policy");
                }}
              >
                {t("privacy_policy")}
              </a>
            </ListItem>
          </List>
          
          {settings && settings.CompanyWebsite && (
            <div style={{ display: "flex", alignItems: "center" }}>
              &copy; {1900 + new Date().getYear() + " "}
              <a
                href={settings.CompanyWebsite}
                className={aClasses}
                style={{ fontFamily: FONT_FAMILY, marginLeft: "4px" }}
                target="_blank"
              >
                {settings.CompanyName}
              </a>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool,
};